export default __webpack_public_path__ + "static/SRF 0100S BIO - Product Specifications & Technical Data-dfbece2be0f467f9627312b9db6a2809.pdf";